import axios from "axios";
import { handleSuccessOne } from "@store/action/GlobalAction";

const REACT_APP_MICRO_FRONTOFFICE_URL =
  process.env.REACT_APP_MICRO_FRONTOFFICE_URL;

export const getDesignbyRadioid = () => async (dispatch) => {
  await axios
    .get(`${REACT_APP_MICRO_FRONTOFFICE_URL}/designs`)
    .then(async (response) => {
      await dispatch({
        type: "GET_DESIGN_BY_RADIO_ID_",
        data: response.data.data,
      });
      localStorage.setItem("currentTheme_f", response.data.data.templates.id);
    });
};
export const editDesignbyRadioid = (radio_id, data) => async (dispatch) => {
  await axios
    .put(`${REACT_APP_MICRO_FRONTOFFICE_URL}/designs/${radio_id}`, data)
    .then((response) => {
      dispatch({
        type: "EDIT_DESIGN_BY_RADIO_ID_SUCCESS",
      });
      handleSuccessOne(response.data.message);
      localStorage.setItem("currentTheme_f", response.data.data?.templates);
      dispatch(getDesignbyRadioid());
    })
    .catch((err) => {
      if (err.response) {
        dispatch({
          type: "EDIT_DESIGN_BY_RADIO_ID_FAIL",
          payload: err.response.data.message,
        });
        setTimeout(() => {
          dispatch({
            type: "EDIT_DESIGN_BY_RADIO_ID_FAIL",
            payload: null,
          });
        }, 3000);
      }
    });
};
export const getFrontofficeTemplates = () => async (dispatch) => {
  await axios
    .get(`${REACT_APP_MICRO_FRONTOFFICE_URL}/templates`)
    .then((response) => {
      dispatch({
        type: "GET_ALL_FRONTOFFICE_TEMPLATES",
        data: response.data.data,
      });
    });
};
export const getFrontofficeTemplateByID = (id) => async (dispatch) => {
  await axios
    .get(`${REACT_APP_MICRO_FRONTOFFICE_URL}/templates/${id}`)
    .then((response) => {
      dispatch({
        type: "GET_FRONTOFFICE_TEMPLATE_BYID",
        data: response.data.data,
      });
    });
};
export const editTemplate = (id, data) => async (dispatch) => {
  const formData = new FormData();
  formData.append("name", data.name);
  formData.append("description", data.description);
  data.cover_picture && formData.append("cover_picture", data.cover_picture);
  await axios
    .put(`${REACT_APP_MICRO_FRONTOFFICE_URL}/templates/${id}`, formData)
    .then((response) => {
      dispatch({
        type: "EDIT_TEMPLATE_SUCCESS",
      });
      handleSuccessOne(response.data.message);
      dispatch(getFrontofficeTemplateByID(id));
    })
    .catch((err) => {
      if (err.response) {
        dispatch({
          type: "EDIT_TEMPLATE_FAIL",
          payload: err.response.data.message,
        });
        setTimeout(() => {
          dispatch({
            type: "EDIT_TEMPLATE_FAIL",
            payload: null,
          });
        }, 3000);
      }
    });
};
